import type { RefObject } from "react";
import { useCallback, useEffect, useRef } from "react";

interface UseDropdownOptionElementRefsInput {
  optionsLength: number;
}

interface UseDropdownOptionElementRefsResult {
  optionsContainerRef: RefObject<HTMLDivElement | null>;
  optionItemRefs: RefObject<Array<HTMLDivElement | null>>;
  onOptionElementRef: (input: {
    index: number;
    element: HTMLDivElement | null;
  }) => void;
}

export function useDropdownOptionElementRefs({
  optionsLength,
}: UseDropdownOptionElementRefsInput): UseDropdownOptionElementRefsResult {
  const optionsContainerRef = useRef<HTMLDivElement>(null);
  const optionItemRefs = useRef<Array<HTMLDivElement | null>>([]);

  useEffect(() => {
    optionItemRefs.current = optionItemRefs.current.slice(0, optionsLength);
  }, [optionsLength]);

  const onOptionElementRef = useCallback(
    (input: { index: number; element: HTMLDivElement | null }) => {
      optionItemRefs.current[input.index] = input.element;
    },
    [],
  );

  return {
    optionsContainerRef,
    optionItemRefs,
    onOptionElementRef,
  };
}
